import type { IconData } from '@stacksjs/iconify-core'

export const caretLeft: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M400.358 496h-36.45L96 256.286L365.811 16.333h34.547ZM144.071 256.358l224.287 200.684V56.892Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default caretLeft
